__turbopack_context__.v({
  "fill-step-coal-mine-canary": "star-module-scss-module__-ecBRW__fill-step-coal-mine-canary",
  "fill-step-cyanora": "star-module-scss-module__-ecBRW__fill-step-cyanora",
  "fill-step-white": "star-module-scss-module__-ecBRW__fill-step-white",
});
